import ApiService from './api.service'

const GeneralService = {

	getConfig: () => ApiService.query('configuracao/url')

}

export default GeneralService



// WEBPACK FOOTER //
// ./src/utils/services/general.service.js